module.exports = __webpack_public_path__ + "static/media/sologo.5907816a.png";